export default {
  autoplay: {
    shouldAutoPlay: true,
    interval: "10000"
  },
  reviews: [
    {
      name: "Stefana Muller",
      jobDescription: "Senior Director, CTO Product and Program Office",
      quote: "monday.com Work OS saves us about 1,850 hrs of staff time and somewhere in the range of $50,000 a month.",
      customerImage: {
        src:
          "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/oscar_image.png",
        alt: "Oscar's customer image"
      },
      companyLogo: {
        src:
          "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/oscar_logo.svg",
        alt: "Oscar logo"
      }
    },
    {
      name: "Charlie MacGregor",
      jobDescription: "Founder & CEO, The Student Hotel",
      quote:
        "Now that we have monday.com Work OS as the backbone of our organization I feel that I have an overview I can trust.",
      customerImage: {
        src:
          "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/the_student_hotel_image.png",
        alt: "The Student Hotel's customer image"
      },
      companyLogo: {
        src:
          "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/the_student_hotel_logo.svg",
        alt: "The Student Hotel logo"
      }
    },
    {
      name: "Tye Rapley-Hawkins",
      jobDescription: "Head of Delivery",
      quote:
        "With monday.com, we’re 30% more efficient at delivering hundreds of campaigns seen by millions of customers.",
      customerImage: {
        src:
          "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/telefonica_image.png",
        alt: "Telefonica's customer image"
      },
      companyLogo: {
        src:
          "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/reviews/telefonica_logo.svg",
        alt: "Telefonica logo"
      }
    }
  ]
};
